import { Card, CardContent } from "../ui/card";
import AppInstallDialog from "../AppInstallDialog";
import { useTranslation } from "@/hooks/useTranslation";
import envelope from "../../assets/envelope-confirmation-cropped.avif";
import ReferAndEarnButton from "./ReferAndEarnButton";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import FollowUsButton from "./FollowUsButton";
import EnableNotificationsDialog from "../EnableNotificationsDialog";
import { PageType } from "../PageType";

export default function OnboardingApplied() {
  const t = useTranslation();
  const isSameRow = useMediaQuery("(min-width: 400px)");

  return (
    <>
      <div className="dark flex flex-col min-w-[320px] w-full max-w-md mx-auto gap-y-4 px-2">
        <Card className="rounded-3xl bg-zinc-900">
          <CardContent className="flex flex-col w-full pt-6">
            <img src={envelope} className="w-full max-w-sm mx-auto" />
            <div className="text-2xl font-semibold tracking-tight text-gray-200 my-4">
              {t.APPLIED_PAGE.TITLE}
            </div>
            <h2 className="text-sm text-zinc-400">
              {t.APPLIED_PAGE.DESCRIPTION}
            </h2>
          </CardContent>
        </Card>
        <div
          className={`grid ${isSameRow ? "grid-cols-2" : "grid-cols-1"} gap-2`}
        >
          <ReferAndEarnButton />
          <FollowUsButton />
        </div>
      </div>
      <AppInstallDialog pageType={PageType.APPLIED} />
      <EnableNotificationsDialog pageType={PageType.APPLIED} />
    </>
  );
}
